var React = require('react');

function Round (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#009245","key":0},[React.createElement("path",{"d":"M1753.283 203.856l166.522-166.522 659.017 659.017L2412.3 862.873z","key":0}),React.createElement("path",{"d":"M1748.67 1187.163l659.11-658.924 166.499 166.545-659.11 658.924z","key":1}),React.createElement("path",{"d":"M474.2 573.8h1935.6v235.6H474.2z","key":2})]),React.createElement("g",{"fill":"#FFA517","key":1},[React.createElement("path",{"d":"M647.719 1847.837l-166.522-166.522 659.017-659.018 166.522 166.522z","key":0}),React.createElement("path",{"d":"M1144.762 2338.715l-659.11-658.924 166.498-166.545 659.11 658.924z","key":1}),React.createElement("path",{"d":"M650.2 1558.8h1935.6v235.6H650.2z","key":2})])]);
}

Round.defaultProps = {"viewBox":"0 0 3060 2376"};

module.exports = Round;

Round.default = Round;
